import $ from 'jquery';
// slick is loaded from the CDN in _Layout <head> and registers on the global jQuery (which the bundle
// also uses via webpack externals) — bundling a second copy added 87KB for nothing.

export default function initSimilarProductsCarouselProad(){
    $('.similar-products-slick-init').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        prevArrow: $(".pp2"),
        nextArrow: $(".nn2"),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}
